<template>
  <div class="c-faqItemContent">
    <div
      class="c-faqItemContent_body"
      v-text="displayContent"
    ></div>
    <div
      class="c-faqItemContent_more"
      v-if="needReadMore && !expanded"
    >
      <a @click="expanded = true">
        すべて見る
        <coconala-icon
          name="chevron-down"
          size="11px"
        />
      </a>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ContentsFaqItemContent',
  props: {
    content: {
      type: String,
      default: ''
    },
    isMyRequest: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      expanded: false
    }
  },
  computed: {
    ...mapGetters('ui', ['isPC']),
    defaultStr() {
      if (this.isPC) {
        return 200
      }

      return 100
    },
    defaultRow() {
      if (this.isPC) {
        return 5
      }

      return 5
    },
    needReadMore() {
      if (this.isMyRequest || !this.content.length) {
        return false
      }

      if (this.content.length > this.defaultStr) {
        return true
      }

      if (this.content.split('\n').length > this.defaultRow) {
        return true
      }

      return false
    },
    displayContent() {
      if (!this.needReadMore || this.expanded) {
        return this.content
      }

      let displayContent = this.content
        .split('\n')
        .slice(0, this.defaultRow)
        .join('\n')

      return this.$util.truncate(displayContent, this.defaultStr)
    }
  }
}
</script>
<style lang="scss" scoped>
a {
  @include link-effect;
}

.c-faqItemContent {
  width: 100%;

  &_body {
    white-space: pre-wrap;
    word-wrap: break-word;
  }

  &_more {
    padding-top: 8px;
    text-align: right;
  }
}

@media (max-width: breakpoint(Requests, M)) {
  .c-faqItemContent {
    margin: 12px 0 0 -38px;
    width: calc(100% + 38px);
  }
}
</style>
